import React from 'react'
import { CardGrid, AppCard } from 'components/Card'

const MyPartnerAppCards = ({ partnerApps }) => {
	return (
		<CardGrid>
			{partnerApps.map(app => (
				<AppCard
					key={app.partnerApp._id}
					id={app.partnerApp._id}
					name={app.partnerApp.appName}
					description={app.partnerApp.description}
					image={app.partnerApp.image}
					// subscribedTo={app.partnerApp.subscribedTo}
					subscribeLink={app.partnerApp.subscribeLink}
					webSite={app.partnerApp.webSite}
					isSubscribed={app.partnerApp.subscribedTo}
					// submitHandler={() => submitHandler(app.partnerApp._id)}
				/>
			))}
		</CardGrid>
	)
}

export default MyPartnerAppCards
